import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 开启按钮 */
const BatchButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

BatchButton.defaultProps = {
  icon: ICON_COLLECTION.START,
  text: '开启',
};

export default BatchButton;
